import { render, staticRenderFns } from "./PetAndProjectTransactionsTabComponent.vue?vue&type=template&id=0fb75eca&scoped=true&"
import script from "./PetAndProjectTransactionsTabComponent.vue?vue&type=script&lang=js&"
export * from "./PetAndProjectTransactionsTabComponent.vue?vue&type=script&lang=js&"
import style0 from "./PetAndProjectTransactionsTabComponent.vue?vue&type=style&index=0&id=0fb75eca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb75eca",
  null
  
)

export default component.exports